import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import translationAl from "./locales/al.json";
import translationDe from "./locales/de.json";
import translationEn from "./locales/en.json";
import translationEs from "./locales/es.json";
import translationFr from "./locales/fr.json";
import translationIt from "./locales/it.json";
import translationMk from "./locales/mk.json";
import translationNl from "./locales/nl.json";
import translationNlBe from "./locales/nl-be.json";
import translationPl from "./locales/pl.json";
import translationPtBr from "./locales/pt-br.json";
import translationPtPt from "./locales/pt-pt.json";
import translationRo from "./locales/ro.json";
import translationSr from "./locales/sr.json";
import translationUk from "./locales/uk.json";

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    react: {
      useSuspense: false
    },
    fallbackLng: 'en',
    debug: false,
    keySeparator: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      "al": {
        translations: translationAl
      },
      "de": {
        translations: translationDe
      },
      "en": {
        translations: translationEn
      },
      "es": {
        translations: translationEs
      },
      "fr": {
        translations: translationFr
      },
      "it": {
        translations: translationIt
      },
      "mk": {
        translations: translationMk
      },
      "nl": {
        translations: translationNl
      },
      "nl-BE": {
        translations: translationNlBe
      },
      "pl": {
        translations: translationPl
      },
      "pt-BR": {
        translations: translationPtBr
      },
      "pt": {
        translations: translationPtPt
      },
      "ro": {
        translations: translationRo
      },
      "sr": {
        translations: translationSr
      },
      "uk": {
        translations: translationUk
      },
    },
    ns: ["translations"],
    defaultNS: "translations"
  });

export default i18n;